import { useState, useEffect } from "react";

/**
 * 自定义Hook：管理beta版本状态
 * 监听localStorage中audit_status值的变化，并提供手动刷新功能
 */
export const useBetaStatus = () => {
  const [isBeta, setIsBeta] = useState<boolean>(false);

  // 检查localStorage中的beta状态
  const checkBetaStatus = () => {
    try {
      const value = localStorage.getItem("audit_status");
      // 约定更新：仅当 value === '1' 时不受限；其余（null/'0'/其他）均视为受限
      // 将 isBeta 语义固定为“是否受限”以匹配各处使用：true=受限，false=不受限
      setIsBeta(value !== "1");
    } catch (error) {
      setIsBeta(false);
    }
  };

  // 手动刷新beta状态
  const refreshBetaStatus = () => {
    checkBetaStatus();
  };

  useEffect(() => {
    // 初始检查
    checkBetaStatus();

    // 监听storage事件（跨标签页同步）
    const handleStorageChange = (e: StorageEvent) => {
      if (e.key === "audit_status") {
        checkBetaStatus();
      }
    };

    // 监听自定义事件（同标签页内同步）
    const handleCustomStorageChange = () => {
      checkBetaStatus();
    };

    // 监听localStorage的原生方法，拦截setItem调用
    const originalSetItem = localStorage.setItem;
    localStorage.setItem = function (key: string, value: string) {
      originalSetItem.apply(this, [key, value]);
      if (key === "audit_status") {
        // 延迟执行，确保localStorage已经更新
        setTimeout(() => {
          window.dispatchEvent(new CustomEvent("betaStatusChanged"));
        }, 0);
      }
    };

    window.addEventListener("storage", handleStorageChange);
    window.addEventListener("betaStatusChanged", handleCustomStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
      window.removeEventListener(
        "betaStatusChanged",
        handleCustomStorageChange
      );
      // 恢复原始的setItem方法
      localStorage.setItem = originalSetItem;
    };
  }, []);

  return {
    isBeta,
    refreshBetaStatus,
  };
};

/**
 * 工具函数：触发beta状态变化事件
 * 当手动修改localStorage时，可以调用此函数通知所有组件更新
 */
export const triggerBetaStatusChange = () => {
  window.dispatchEvent(new CustomEvent("betaStatusChanged"));
};
